import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import styles from './CookieConsent.module.css';
import { hasCookieConsent, acceptCookieConsent } from '../../utils/cookieConsent';

function CookieConsent() {
  const { t } = useTranslation();
  const [accepted, setAccepted] = useState(hasCookieConsent());

  if (accepted) return null;

  const handleAccept = () => {
    acceptCookieConsent();
    setAccepted(true);
  };

  return (
    <div className={styles.overlay} role="dialog" aria-live="polite" aria-label={t('cookieConsent.title')}>
      <div className={styles.banner}>
        <div className={styles.iconWrap}>🍪</div>
        <div className={styles.textBlock}>
          <h2 className={styles.title}>{t('cookieConsent.title')}</h2>
          <p className={styles.text}>
            <Trans
              i18nKey="cookieConsent.text"
              // eslint-disable-next-line jsx-a11y/anchor-has-content
              components={[<Link key="0" to="/privacy" />]}
            />
          </p>
        </div>
        <button type="button" className={styles.acceptButton} onClick={handleAccept}>
          {t('cookieConsent.accept')}
        </button>
      </div>
    </div>
  );
}

export default CookieConsent;
